import { render, staticRenderFns } from "./LoteWidget.vue?vue&type=template&id=037a8764&scoped=true"
import script from "./LoteWidget.vue?vue&type=script&lang=js"
export * from "./LoteWidget.vue?vue&type=script&lang=js"
import style0 from "./LoteWidget.vue?vue&type=style&index=0&id=037a8764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037a8764",
  null
  
)

export default component.exports